'use strict';

const DOMESTIC_LOCALE = 'en_IN';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
}

/**
 * Adjusts the maximum height of the PLP (Product Listing Page) filter sidebar
 * dynamically on desktop viewports.
 *
 * - Applies only when the viewport width is greater than 1023px.
 * - Calculates the available space below the header and sticky header.
 * - Sets the `max-height` of `.refinement-bar-section` to fit within the viewport,
 *   leaving extra padding at the bottom.
 *
 * @function plpFilterMaxHeight
 * @returns {void}
 */
function plpFilterMaxHeight() {
    if ($(window).width() > 1023) {
        var itemCountTop = $('.header').height() + $('.plp-sticky-header').outerHeight() + 24;
        var filterTop = itemCountTop;
        var filterMaxHeight = $(window).height() - filterTop;
        // eslint-disable-next-line quote-props
        $('.refinement-bar-section').css({ 'max-height': filterMaxHeight - 60 });
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement-content').each(function () {
        var content = $(this);
        var contentID = $(this).attr('id');

        if (content.hasClass('show')) {
            $results.find('#' + contentID)
                .addClass('show')
                .siblings('.refinement-header')
                .removeClass('collapsed')
                .attr('aria-expanded', 'true');
        } else {
            $results.find('#' + contentID)
                .removeClass('show')
                .siblings('.refinement-header')
                .addClass('collapsed')
                .attr('aria-expanded', 'false');
        }
        if (content.find('.values').hasClass('filter-expanded')) {
            $results.find('#' + contentID).children('.values')
                .addClass('filter-expanded')
                .children('.filter-option')
                .removeClass('d-none');
        } else {
            $results.find('#' + contentID).children('.values')
                .removeClass('filter-expanded')
                .children('.filter-option')
                .addClass('d-none');
        }
    });

    updateDom($results, '.refinements');
}

/**
 *  function to generate Price filter URL
 * @param {number} fromVal pmin value
 * @param {number} toVal pmax value
 * @returns {string} price filter URL
 */
function getFilterUrl(fromVal, toVal) {
    const $priceRangeSlider = $('.js-range-slider');
    var filterUrl = $priceRangeSlider.attr('data-url');
    var priceFromVal = typeof fromVal !== 'undefined' ? fromVal : $priceRangeSlider.data('from');
    var priceToVal = typeof toVal !== 'undefined' ? toVal : $priceRangeSlider.data('to');
    var priceFilterGstPercent = parseFloat($priceRangeSlider.data('gst-percent')) || 0;
    var parsedUrl;
    var searchMinPrice = priceFromVal;
    var searchMaxPrice = priceToVal;

    if (!filterUrl) {
        return '';
    }

    if ($priceRangeSlider.data('locale') === DOMESTIC_LOCALE && priceFilterGstPercent) {
        searchMinPrice = parseFloat(priceFromVal);
        searchMaxPrice = parseFloat(priceToVal);

        if (!Number.isNaN(searchMinPrice)) {
            searchMinPrice = parseFloat((Math.max(0, searchMinPrice - 5) / (1 + (priceFilterGstPercent / 100))).toFixed(2));
        }

        if (!Number.isNaN(searchMaxPrice)) {
            searchMaxPrice = parseFloat(((searchMaxPrice + 4.99) / (1 + (priceFilterGstPercent / 100))).toFixed(2));
        }
    }

    try {
        parsedUrl = new URL(window.location.origin + filterUrl);
    } catch (error) {
        return '';
    }

    parsedUrl.searchParams.set('pmin', searchMinPrice);
    parsedUrl.searchParams.set('pmax', searchMaxPrice);
    parsedUrl.searchParams.set('dpmin', priceFromVal);
    parsedUrl.searchParams.set('dpmax', priceToVal);

    if (priceFilterGstPercent) {
        parsedUrl.searchParams.set('pgst', priceFilterGstPercent);
    }

    return parsedUrl.pathname + parsedUrl.search;
}

/**
 *  function to generate filter URL with changes in querystring
 * @param {number} filterUrl filter url
 * @returns {string} url with modified querystring
 */
function addSortRuleToFilterUrl(filterUrl) {
    var parsedUrl;
    let url = filterUrl;
    var selectedSortingRule = $('.container').find('[name=sort-order]').find('option:selected').data('id');

    try {
        parsedUrl = new URL(window.location.protocol + '//' + window.location.hostname + filterUrl);
    } catch (error) {
        parsedUrl = '';
    }

    if (parsedUrl && selectedSortingRule) {
        parsedUrl.searchParams.set('srule', selectedSortingRule);
        url = parsedUrl.pathname + parsedUrl.search;
    }

    return url;
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.sort-refinement-section',
        '.filter-header',
        '.result-count',
        '.sticky-header-row',
        '.plp-product-count'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    // Only update shape tiles if the response has actual tile items (wrapper is always present)
    var $shapeTilesInResponse = $results.find('.shape-tiles');
    if ($shapeTilesInResponse.length && $shapeTilesInResponse.find('.shape-tile').length) {
        updateDom($results, '.shape-tiles');
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * price slider values prettifier
 * @param {number} priceValue price range value
 * @returns {number} formatted price value
 */
function prettify(priceValue) {
    const $priceRangeSlider = $('.js-range-slider');
    var currencySymbol = $priceRangeSlider.data('currency-symbol');
    var locale = $priceRangeSlider.data('locale') === DOMESTIC_LOCALE ? 'en-IN' : 'en';
    return currencySymbol + ' ' + parseInt(priceValue, 10).toLocaleString(locale);
}

/**
 *  Initialize Price Filter slider
 */
function priceFilterSlider() {
    var priceOnChange;
    const $priceRangeSlider = $('.js-range-slider');

    if ($priceRangeSlider.data('locale') === DOMESTIC_LOCALE) {
        priceOnChange = function (data) {
            $('.price-input-min').val(Math.floor(data.from).toLocaleString('en-US'));
            $('.price-input-max').val(Math.round(data.to).toLocaleString('en-US'));
        };
    } else {
        priceOnChange = function (data) {
            $('.price-input-min').val(data.from.toFixed(2));
            $('.price-input-max').val(data.to.toFixed(2));
        };
    }

    $('.js-range-slider').ionRangeSlider({
        skin: 'round',
        type: 'double',
        hide_min_max: true,
        extra_classes: 'ion-pricefilter-slider',
        prettify: prettify,
        onChange: priceOnChange,
        onFinish: function (data) {
            if (!(data.from === this.from && data.to === this.to)) {
                $('body').trigger('handleFilters', {
                    context: $('.price-slider'), priceFilter: true, from: data.from, to: data.to
                });
            }
        },
        min_interval: 10
    });
}

/**
 * update item count
 */
function updateItemCount() {
    var itemCount = parseInt($('.item-count-dynamic').val(), 10) || '';
    $('.dynamic-count-display').html(itemCount);
    if (!itemCount) {
        $('.no-results-filters-recommendations-page').removeClass('d-none');
        $('.refinement-bar-section, .plp-product-wrapper').addClass('d-none');
    }
}

/**
 * Add or remove 'filters-available' class based on .sticky-header-row content
 */
function toggleStickyHeaderRowState() {
    if ($('.sticky-header-row').is(':empty')) {
        $('.sticky-header-row').removeClass('filters-available');
    } else {
        $('.sticky-header-row').addClass('filters-available');
    }
}

$('body').on('click', '.read-toggle', function () {
    var $toggle = $(this);
    var $msg = $toggle.siblings('.refinement-attribute-message');

    if ($msg.hasClass('collapsed')) {
        $msg.removeClass('collapsed');
        $toggle.text('Read less');
    } else {
        $msg.addClass('collapsed');
        $toggle.text('Read more');
    }
});

$('body').on('input', '.price-input', function () {
    var preventEvtRegex = /[^0-9]/g;
    var inputVal = $(this).val();
    var newValue = inputVal.replace(preventEvtRegex, '');
    $(this).val(newValue);
});

$('body').on('change', '.price-input', function () {
    var enteredMinPrice = parseFloat(String($('.price-input-min').val()).replace(/,/g, ''));
    var enteredMaxPrice = parseFloat(String($('.price-input-max').val()).replace(/,/g, ''));
    const $priceRangeSlider = $('.js-range-slider');
    var minPrice;
    var maxPrice;
    if ($priceRangeSlider.data('locale') === DOMESTIC_LOCALE) {
        minPrice = Math.floor($('.price-input.price-input-min').attr('data-min-price'));
        maxPrice = Math.floor($('.price-input.price-input-max').attr('data-max-price'));
    } else {
        minPrice = parseFloat($('.price-input.price-input-min').attr('data-min-price'));
        maxPrice = parseFloat($('.price-input.price-input-max').attr('data-max-price'));
    }

    if (Number.isNaN(enteredMinPrice)) {
        enteredMinPrice = minPrice;
    }

    if (Number.isNaN(enteredMaxPrice)) {
        enteredMaxPrice = maxPrice;
    }

    // Ensure entered prices are within the valid range
    if (enteredMinPrice >= maxPrice) {
        enteredMinPrice = minPrice;
        enteredMaxPrice = maxPrice;
    } else if (enteredMinPrice < minPrice) {
        enteredMinPrice = minPrice;
    } else if (enteredMaxPrice > maxPrice) {
        enteredMaxPrice = maxPrice;
    }

    $('body').trigger('handleFilters', {
        context: $('.price-slider'), priceFilter: true, from: enteredMinPrice, to: enteredMaxPrice
    });
});

$('body').on('shown.bs.collapse', '.refinement-content', function () {
    $(this).closest('.refinement').addClass('expanded');
});

$('body').on('hidden.bs.collapse', '.refinement-content', function () {
    $(this).closest('.refinement').removeClass('expanded');
});

$('body').on('handleFilters', function (e, data) {
    if ($('.custom-plp-search-results').length) { return; }
    data.context.trigger('search:filter', e);
    var attributeId = '#' + data.context.find('span').last().attr('id');
    var filterUrl;
    var shouldScrollToTop = !(
        data.context.closest('.shape-tile.filter-value').length
        || (data.context.closest('.filter-value').length && data.context.hasClass('selected-filter'))
    );
    if (data.priceFilter) {
        filterUrl = getFilterUrl(data.from, data.to);
    } else {
        filterUrl = data.context.data('href');
    }

    if (!filterUrl) {
        return;
    }

    filterUrl = addSortRuleToFilterUrl(filterUrl);

    $.spinner().start();

    $.ajax({
        url: filterUrl,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: data.context.data('href')
        },
        method: 'GET',
        success: function (response) {
            parseResults(response);
            priceFilterSlider();
            $.spinner().stop();
            $('body').trigger('search:updateSearchURL', { searchURL: filterUrl });
            if ($('.filter-header').children().length === 0) {
                $('.refinement-bar, .modal-background').hide();
                $('body').removeClass('overflow-hidden');
            }
            updateItemCount();

            toggleStickyHeaderRowState();
            if (shouldScrollToTop) {
                $('html,body').animate({ scrollTop: 0 }, 500);
            }
        },
        error: function () {
            $.spinner().stop();
            $(attributeId).parent('button').focus();
        }
    });

    $('.plp-slick-carousel').slick('unslick');

    $('.plp-slick-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Closes the "Sort By" dropdown if it is currently opened.
 *
 * This function checks for an opened `.custom-drop-down` element inside the
 * `.sort-refinement-section`. If found, it resets the arrow rotation,
 * hides the option list, and removes the `opened` class to close the dropdown.
 */
function closeSortByFilterOnOtherFilterClick() {
    if ($('.sort-refinement-section').find('.custom-drop-down').hasClass('opened')) {
        var $this = $('.sort-refinement-section').find('.custom-drop-down');
        $this.find('.down-arrow').removeClass('rotate-arrow');
        $this.parent().find('.custom-option-values').css('display', 'none');
        $this.removeClass('opened');
    }
}

$('body').on('search:updateSearchURL', function (e, data) {
    var currentURL = new URL(window.location);
    var searchURL = new URL(window.location.protocol + '//' + window.location.hostname + data.searchURL);
    if (searchURL && searchURL.searchParams && currentURL) {
        // Retain lang param if there in the current url
        var lang = currentURL && currentURL.searchParams && currentURL.searchParams.get('lang');
        if (lang) {
            searchURL.searchParams.set('lang', lang);
        }

        // Update page querystring before removing cgid
        $('.page').data('querystring', searchURL.search);
        $('.page').attr('data-querystring', searchURL.search);

        // Remove cgid if not already in the current url, as it would not be needed in the new storefront urls
        var currentCgid = currentURL && currentURL.searchParams && currentURL.searchParams.get('cgid');
        if (!currentCgid) {
            searchURL.searchParams.delete('cgid');
        }

        // Update url
        var newQueryString = searchURL.search;
        window.history.replaceState(null, '', `${window.location.pathname}${newQueryString}`);
    }
});

// on page load
$(document).ready(function () {
    if ($('.plp-sticky-header-container').length > 0) {
        $('.no-search-results').css('margin-top', '100px');
    }
});

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.modal-background').removeClass('d-none');
            $('body').addClass('overflow-hidden');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('body').on('click', '.refinement-bar button.close, .modal-background, .sort-icon-close', function () {
            $('.refinement-bar, .modal-background').hide();
            $('body').removeClass('overflow-hidden');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
            $('.refinement').removeClass('expanded');
            $('.refinement-header').addClass('collapsed');
            $('.refinement-content').removeClass('show');
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('body').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            var sortUrl = this.value;
            var url = new URL(sortUrl, window.location.origin);
            if (url.searchParams.has('sz')) {
                url.searchParams.set('start', 0);
                url.searchParams.set('sz', parseInt($('.default-page-size').val(), 10));
            }
            var updatedURL = url.toString();
            $(this).trigger('search:sort', updatedURL);
            $.ajax({
                url: url.toString(),
                data: { selectedUrl: updatedURL },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $('body').trigger('search:updateDom', '.product-grid');
                    updateItemCount();
                    $('body').trigger('search:updateSearchURL', { searchURL: url.toString() });
                    $('.sort-refinement-section .custom-option-values .selected-value, .custom-drop-down-sticky .selected-value').text($('.sort-refinement-section .custom-drop-down .selected-value').text());
                    $('.modal-background').hide();
                    $('body').removeClass('overflow-hidden');
                    priceFilterSlider();
                    $('html,body').animate({ scrollTop: 0 }, 500);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
        $('body').on('click', '.sort-by .custom-drop-down', function () {
            var windowWidth = $(window).outerWidth();
            if (windowWidth < 1024) {
                $('.modal-background').show();
                $('body').addClass('overflow-hidden');
            }
        });

        $('body').on('click', '.custom-drop-down-sticky', function () {
            $('.sort-by .custom-drop-down').trigger('click');
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            if ($(window).width() > 1023) {
                $('.refinement-bar, .modal-background').hide();
                $('body').removeClass('overflow-hidden');
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
                $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
                $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            }

            plpFilterMaxHeight();
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    $('body').trigger('search:updateDom', '.grid-footer');
                    updateSortOptions(response);
                    priceFilterSlider();
                    $.spinner().stop();
                    updateItemCount();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .reset-filter-btn',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                if ($(this).hasClass('reset-filter-btn')) {
                    var href = $(this).data('seo-href') || $(this).data('href');
                    if (href) {
                        if (href.indexOf('Search-ShowAjax') > -1) {
                            href = href.replace('Search-ShowAjax', 'Search-Show');
                        }
                        $.spinner().start();
                        window.location.href = href;
                    }
                } else {
                    if ($(this).hasClass('refinement-value-btn')) {
                        $(this).toggleClass('selected');
                    }
                    $('.no-results-filters-recommendations-page').addClass('d-none');
                    $('.refinement-bar-section, .plp-product-wrapper').removeClass('d-none');
                    $('body').trigger('handleFilters', { context: $(this) });
                }
            }
        );

        $('body').on('show.bs.collapse', '.refinement-content', function () {
            $(this).siblings('.refinement-header').find('.refinement-select-count').addClass('d-none');

            closeSortByFilterOnOtherFilterClick();
        });

        $('body').on('hide.bs.collapse', '.refinement-content', function () {
            $(this).siblings('.refinement-header').find('.refinement-select-count').removeClass('d-none');

            closeSortByFilterOnOtherFilterClick();
        });
    },

    filtersShowMore: function () {
        $('body').on('click', '.fliter-show-toggle', function () {
            var $filterOption = $(this).closest('ul');
            $filterOption.find('.filter-option').toggleClass('d-none');
            $filterOption.toggleClass('filter-expanded');
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    onPopState: function () {
        $(window).on('popstate', function () {
            window.location = window.location.href;
        });
    },

    priceFilterSliderInit: function () {
        priceFilterSlider();
    },

    plpFilterMaxHeightInit: function () {
        plpFilterMaxHeight();
    },

    plpTopSticky: function () {
        $(window).on('load scroll resize', function () {
            var scrollTop = $(window).scrollTop();
            var plpStickyHeader = $('.plp-sticky-header');
            if (scrollTop > 0) {
                plpStickyHeader.addClass('sticky');
            } else {
                plpStickyHeader.removeClass('sticky');
            }
        });
    },
    tryOn: function () {
        $('body').on('click', '#tryOnButton', function (e) {
            var ckcBrandKey = $('#ckcBrandKey').val();
            var ckcMirrArCDNLink = $('#ckcMirrArCDNLink').val();
            e.preventDefault();
            var productId = $(this).closest('.product').data('pid');
            var script = document.createElement('script');
            var options = {
                brandId: ckcBrandKey,
                variantSku: productId
            };

            script.src = ckcMirrArCDNLink;
            script.onload = function () {
                if (typeof window.initMirrarUI === 'function') {
                    window.initMirrarUI(productId, options);
                }
            };
            document.body.append(script);
        });
    },
    toggleStickyHeaderRowState
};
